import { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import api from "../api";              // helper we just created

export default function AddressForm() {
  const [addr, setAddr] = useState("");
  const [saved, setSaved] = useState(false);

  // fetch after every login (token present)
  useEffect(() => {
    async function fetchAddr() {
      try {
        const { data } = await api.get("/users/me");
        setAddr(data.payout_address || "");
      } catch (err) {
        console.error("fetch /users/me failed", err);
      }
    }
    fetchAddr();
  }, []);                         // run once on mount

  const save = async () => {
    if (!addr) return;
    await api.put("/users/me/address", { onchain: addr });
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div style={{ maxWidth: 320, margin: "1rem auto", padding: 16,
                  border: "1px solid #ccc", borderRadius: 8 }}>
      <input
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
        value={addr}
        onChange={e => setAddr(e.target.value.trim())}
        placeholder="Paste your bc1… address"
      />
      {addr && (
        <QRCodeSVG
          value={addr}
          size={128}
          style={{ display: "block", margin: "0 auto 12px" }}
        />
      )}
      <button onClick={save} disabled={!addr}
              style={{ width: "100%", padding: 10 }}>
        Save address
      </button>
      {saved && (
        <p style={{ color: "green", fontSize: 14, marginTop: 8 }}>
          Saved ✔
        </p>
      )}
    </div>
  );
}
